module.exports = __webpack_public_path__ + "static/media/event-4.d11642a6.jpg";